import { defineMessages } from 'react-intl';

export default defineMessages({
    spouseLabel: {
        id: 'common.directives.pa.templates.ml-pa-driver-details.Please choose a spouse for x',
        defaultMessage: 'Please choose a spouse for {spouse}',
    },
    addNewPersonAsSpouse: {
        id: 'common.directives.pa.templates.ml-pa-driver-details.Add a new person as spouse',
        defaultMessage: 'Add a new person as spouse',
    },
    pleaseSelectSpouse: {
        id: 'common.directives.pa.templates.ml-pa-edit-driver.Please select a spouse from the list.',
        defaultMessage: 'Please select a spouse from the list.',
    },
    infoForAddingDriverAsSpouse: {
        id: 'common.directives.pa.templates.ml-pa-edit-driver.When adding a spouse as a driver, additional driver information will be needed after Quote Results.',
        defaultMessage: 'When adding a spouse as a driver, additional driver information will be needed after Quote Results.',
    }
});
